import React, {Component} from 'react';
import $ from 'jquery'
import * as Common from '../CommonControlls/CommonJs';
import MainLayout from '../CommonControlls/MainLayout';
import Topmenu from '../CommonControlls/Topmenubar';
import {connect} from 'react-redux'
import {Link} from 'react-router-dom';
import DropDown from '../CommonControlls/DropdownRendrer'
import AlertModal from '../CommonControlls/AlertModal';
import DatePicker from "react-datepicker";
import moment from "moment";

const mapStateToProps = (store) => {
    return store
}

const mapDispatchToProps = (dispatch) => {
    return {
        ShowAlert: (Settings) => {
            dispatch({type: "UpdateAlert", payload: Settings})
        },
        ShowLoader: (Isloading) => {
            dispatch({type: "UpdateLoader", payload: Isloading})
        },
    }
}

class DistrictWiseTarget_Add extends Component {

    constructor(props) {
        super(props);
        this.state = {
            Id: 0,

            alertModalData: {
                title: "",
                message: "",
                First_Callback: () => {
                },
                Second_Callback: () => {
                },
                type: 1,
            },

            startDate: new Date(),
            endDate: new Date(),

            status: false,

            date: '',

            ProvinceLoader: false,
            Provincelist: [],
            ProvinceId: 0,

            SrId: 0,
            SrList: [],
            FilteredSrs: [],

            FilteredDistrictlist: [],
            //
            // TehsilLoader: false,
            // Tehsillist: [],
            // FilteredTehsillist: [],
            // TehsilId: 0,

            DistrictLoader: false,
            Districtlist: [],
            DistrictId: 0,

        };
    }

    HandleAutoSuggestValChange = (fieldId, value) => {
        if (fieldId === 'ProvinceId') {
            const tempSrs = this.state.SrList
            const filteredSrs = tempSrs.filter(item => item.provinceid === value)

            this.setState({
                FilteredSrs: filteredSrs,
                ProvinceId: value
            })
        }
        if (fieldId === 'SrId') {
            const tempDistricts = this.state.Districtlist
            const filteredSelectedDistricts = tempDistricts.filter(function (obj) {
                return obj.subrecipientid === value
            });
            this.setState({
                FilteredDistrictlist: filteredSelectedDistricts,
                SrId: value,
            })
        }
        if(fieldId === 'DistrictId') {
            this.setState({
                DistrictId: value
            })
        }

    }

    render() {

        return (

            <div>
                <MainLayout/>
                <AlertModal  {...this.state.alertModalData} />
                <div id="right-panel" class="right-panel">
                    <Topmenu PageTitle={"Add District Wise Target"} isShowAddBtn={false}/>
                    <div class="content col-md-12 col-lg-12 d-flex justify-content-center">

                        {/* <div class="PageHeader_Container">
                            <h2>{this.state.Id==0?"Add User":"Edit User"}</h2>
                        </div> */}

                        <div class="card col-md-8 col-lg-8">
                            <div class="card-body row">

                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <form onSubmit={this.SubmitForm} novalidate>
                                        <div>

                                            <div
                                                className="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <label htmlFor=""><span style={{color: "red"}}>* </span>Target</label>
                                                <input autoComplete="off" type="number" className="form-control"
                                                       id="target"
                                                       placeholder="Enter target" required/>
                                            </div>

                                            <div
                                                className="formInput_Container Search_InputSelectContainer col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <label htmlFor="">Province</label>
                                                <DropDown
                                                    multi={false}
                                                    dropdownRenderer={false}
                                                    create={false}
                                                    onChange={this.HandleAutoSuggestValChange}
                                                    Type="ProvinceId"
                                                    options={this.state.Provincelist}
                                                    val={this.state.ProvinceId}
                                                    addPlaceholder=""
                                                    disabled={false}
                                                    loading={this.state.ProvinceLoader}
                                                    searchBy="name"
                                                    labelField="name"
                                                    valueField="id"
                                                    contentRenderer={false}
                                                    placeholder="Select"
                                                />
                                            </div>

                                            <div
                                                className="formInput_Container Search_InputSelectContainer col-lg-12 col-md-12 col-sm-12 col-xs-122">
                                                <label htmlFor="">Sub Recipient</label>
                                                <DropDown
                                                    multi={false}
                                                    dropdownRenderer={false}
                                                    create={false}
                                                    onChange={this.HandleAutoSuggestValChange}
                                                    Type="SrId"
                                                    options={this.state.FilteredSrs}
                                                    val={this.state.SrId}
                                                    addPlaceholder=""
                                                    disabled={false}
                                                    searchBy="name"
                                                    labelField="name"
                                                    valueField="id"
                                                    contentRenderer={false}
                                                    placeholder="Select"
                                                />
                                            </div>

                                            <div class="formInput_Container col-md-12 col-lg-12 col-12">
                                                <label for=""><span style={{color: "red"}}>* </span>District</label>
                                                <DropDown
                                                    multi={false}
                                                    dropdownRenderer={false}
                                                    create={false}
                                                    onChange={this.HandleAutoSuggestValChange}
                                                    Type="DistrictId"
                                                    options={this.state.FilteredDistrictlist}
                                                    val={this.state.DistrictId}
                                                    addPlaceholder=""
                                                    disabled={false}
                                                    loading={this.state.DistrictLoader}
                                                    searchBy="name"
                                                    labelField="name"
                                                    valueField="id"
                                                    contentRenderer={false}
                                                    placeholder="Select"
                                                />
                                            </div>

                                            <div className="row">
                                                <div className="col-lg-6  col-md-6">
                                                    <label htmlFor="">Start Date</label>
                                                    <DatePicker
                                                        selected={this.state.startDate}
                                                        onChange={(date) => this.setState({startDate: date})}

                                                    />
                                                </div>
                                                <div className="col-lg-6 col-md-6">
                                                    <label htmlFor="">End Date</label>
                                                    <DatePicker
                                                        selected={this.state.endDate}
                                                        onChange={(date) => {
                                                            this.setState({
                                                                endDate: date
                                                            })
                                                        }}

                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-12 col-lg-12"
                                                 style={{marginTop: "16px", marginLeft: '15px'}}>
                                                <label className="CheckBox_container">
                                                    <span>Status</span>
                                                    <input type="checkbox"
                                                           onChange={(e) => this.setState({
                                                               status: e.target.checked
                                                           })}
                                                           checked={this.state.status}
                                                    />
                                                    <span className="CheckBox_checkmark"></span>
                                                </label>
                                            </div>

                                            {/*<div class="formInput_Container col-md-12 col-lg-12 col-12">*/}
                                            {/*    <label for=""><span style={{color: "red"}}>* </span> Tehsil</label>*/}
                                            {/*    <DropDown*/}
                                            {/*        multi={false}*/}
                                            {/*        dropdownRenderer={false}*/}
                                            {/*        create={false}*/}
                                            {/*        onChange={this.HandleAutoSuggestValChange}*/}
                                            {/*        Type="TehsilId"*/}
                                            {/*        options={this.state.FilteredTehsillist}*/}
                                            {/*        val={this.state.TehsilId}*/}
                                            {/*        addPlaceholder=""*/}
                                            {/*        disabled={false}*/}
                                            {/*        loading={this.state.TehsilLoader}*/}
                                            {/*        searchBy="name"*/}
                                            {/*        labelField="name"*/}
                                            {/*        valueField="id"*/}
                                            {/*        contentRenderer={false}*/}
                                            {/*        placeholder="Select"*/}
                                            {/*    />*/}
                                            {/*</div>*/}

                                            <div
                                                class="form_footer formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                <button type="submit" id="Form_SaveBtn" class="btn btn_style1"
                                                >{this.state.Id === 0 ? 'Save' : 'Update'}
                                                </button>
                                                {/* <button type="button" onClick={this.onDelete} id="Form_DeleteBtn" class="btn btn_style2" hidden={this.state.Id== this.state.loggedinUser ? true: this.state.Id==0?true:false}>Delete</button> */}
                                                <Link to="/DistrictWise_Target">
                                                    <button type="button" id="Form_CancelBtn"
                                                            class="btn btn_style3">Cancel
                                                    </button>
                                                </Link>

                                                {/* Hide button for reset */}
                                                <Link style={{display: "none"}} to="/DistrictWise_Target">
                                                    <button id="Form_ResetBtn" type="button"
                                                            class="btn initial-btn Cancel-Form-btn Form_Btn">Reset
                                                    </button>
                                                </Link>
                                            </div>

                                        </div>
                                    </form>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
            </div>

        )
    }

    componentWillMount() {
        if (this.props.UserAuthentication.AuthToken === "") {
            this.props.history.push("/Login")
        }

        Common.parseJwt(this.props.UserAuthentication.AuthToken, (user) => {
            this.setState({
                loggedinUser: user.id
            })
        })
    }

    componentDidMount() {
        var Id = Common.GetId()
        if (Id !== 0) {
            this.DistrictWiseTarget(Id)
        }

        this.SelectProvinces()
        this.SelectDistricts()
        this.SelectSubReciepents()
        // this.SelectTehsil()

    }

    ResetForm = () => {
        $("#target").val("")
    }
    SubmitForm = (e) => {
        e.preventDefault()

        const formData = {
            id: this.state.Id,
            setttings_id: 0,
            district_id: this.state.DistrictId,
            target: $('#target').val(),
            provinceId: this.state.ProvinceId,
            subrecipientId: this.state.SrId,
            status: this.state.status,
            startDate: moment(this.state.startDate).format('YYYY-MM-DD HH:mm:ss.SS'),
            endDate: moment(this.state.endDate).format('YYYY-MM-DD HH:mm:ss.SSS'),
            createdBy: this.props.UserAuthentication.UserInfo.id,
            editedBy: 0
        }

        Common.Ajax(this.props.UserAuthentication.AuthToken, "Post", false, this.state.Id === 0 ?
            Common.BaseUrlAPI+"/api/Settings/InsertDistrictWiseTargets" : Common.BaseUrlAPI+"/api/Settings/UpdateDistrictWiseTargets", JSON.stringify(formData), (resp) => {
            if (resp.status === true) {
                this.props.ShowLoader({Isloading: false})
                $("#Form_ResetBtn").click()
                this.ResetForm()
                this.props.history.push('/DistrictWise_Target')
                this.props.ShowAlert({Type: 1, Msg: this.state.Id === 0 ? "Saved successfully": "Updated successfully"})
                setTimeout(() => {
                    $("#Alertmsgbtn").click()
                }, 50);
            } else {
                this.props.ShowLoader({ Isloading: false })
                this.props.ShowAlert({ Type: 0, Msg: resp.message })
                setTimeout(() => {
                    $("#Alertmsgbtn").click()
                }, 50);
            }
        },
        (error) => {
            this.props.ShowLoader({Isloading: false})
            this.props.ShowAlert({Type: 0, Msg: "Something went wrong, please try again."})
            setTimeout(() => {
                $("#Alertmsgbtn").click()
            }, 50);
        })
    }

    SelectSubReciepents = () => {
        Common.Ajax(this.props.UserAuthentication.AuthToken, 'GET', false, Common.APILinks.SelectALl_SubRecipient, {}, (resp) => {
            if (resp.status) {
                this.setState({
                    SrList: resp.data.map(d => ({id: d.id, name: d.short_name, ...d}))
                })
            }
        })
    }

    SelectProvinces = () => {
        this.setState({ProvinceLoader: true})
        Common.Ajax("", "Get", false, Common.APILinks.SelectAll_Province, {isPaginate: false},
            (Result) => {
                if (Result.status === true) {
                    console.log(Result)
                    this.setState({
                        Provincelist: Result.data,
                        ProvinceLoader: false
                    })
                } else {
                    this.setState({
                        ProvinceLoader: false
                    })
                    this.props.ShowAlert({Type: 0, Msg: Result.message})
                    setTimeout(function () {
                        $("#Alertmsgbtn").click()
                    }, 50);
                }
            },
            (error) => {
                this.setState({
                    ProvinceLoader: false
                })
                this.props.ShowAlert({Type: 0, Msg: "Something went wronge, please try again"})
                setTimeout(function () {
                    $("#Alertmsgbtn").click()
                }, 50);
            }
        )
    }
    SelectDistricts = () => {
        this.setState({DistrictLoader: true})
        Common.Ajax("", "Get", false, Common.APILinks.SelectAll_District, {isPaginate: false},
            (Result) => {
                if (Result.status === true) {
                    this.setState({
                        Districtlist: Result.data,
                        DistrictLoader: false
                    })
                } else {
                    this.setState({
                        DistrictLoader: false
                    })
                    this.props.ShowAlert({Type: 0, Msg: Result.message})
                    setTimeout(function () {
                        $("#Alertmsgbtn").click()
                    }, 50);
                }
            },
            (error) => {
                this.setState({
                    DistrictLoader: false
                })
                this.props.ShowAlert({Type: 0, Msg: "Something went wrong, please try again"})
                setTimeout(function () {
                    $("#Alertmsgbtn").click()
                }, 50);
            }
        )
    }
    DistrictWiseTarget = (id) => {
        Common.Ajax(this.props.UserAuthentication.AuthToken, 'GET', false, Common.BaseUrlAPI + "/api/Settings/SelectDistrictWiseTargets", {}, (resp) => {
            if (resp.status) {
                const selected = resp.data.find(d => d.id === id)
                this.LoadDataInEditMode(selected)
            }
        })
    }
    LoadDataInEditMode = (data) => {
        this.setState({
            Id: data.id,
            startDate: new Date(data.startDate),
            endDate: new Date(data.endDate),
            DistrictId: data.district_id,
            ProvinceId: data.provinceId,
            SrId: data.subrecipientId,
            status: data.status,
        })
        $('#target').val(data.target)
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(DistrictWiseTarget_Add);
